export enum SyncOrSwimFeatureFlags {
    EnableDisplayCustomFieldsNova = 'ENABLE_DISPLAY_CUSTOM_FIELDS_NOVA',
    EnableDisplayCustomFieldsNovaCandidates = 'ENABLE_DISPLAY_CUSTOM_FIELDS_NOVA_CANDIDATES',
    EnableAccountManagersCandidatesCustomFieldsExportNova = 'ENABLE_ACCOUNT_MANAGERS_CANDIDATES_CUSTOM_FIELDS_EXPORT_NOVA'
}
